module.exports = __webpack_public_path__ + "img/Simple-Salad.eb734989.png";